import { t } from 'i18next';
import {
  ChipsWrapperStyled,
  InfoTypography,
  PreviewActionButton,
  PreviewCardBody,
  PreviewCardFooter,
  PreviewCardHeader,
  PreviewCardHeading,
  PreviewCardInfoWrapper,
  PreviewCardWrapper,
  PreviewChip,
  PreviewDescription,
  ReportFilled20Px,
  StarFilled16Px,
  ViewsTypography,
} from './preview-card.styled';

export type PreviewCardProps = {
  key: string;
  heading?: string;
  isFavourite?: boolean;
  views: number;
  chips?: PreviewChipProps[];
  description?: string;
  lastRun?: string;
  visualised?: string;
  action?: string;
  handlePreviewAction?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export interface PreviewChipProps {
  color: string;
  label: string;
}

export function PreviewCard(props: Partial<PreviewCardProps>) {
  return (
    <PreviewCardWrapper {...props}>
      <PreviewCardHeader
        header={
          <>
            <ReportFilled20Px color="#0060A9" style={{ minWidth: 20 }} data-testid="report-icon" />
            <PreviewCardHeading>{props.heading}</PreviewCardHeading>
          </>
        }
        action={props.isFavourite ? <StarFilled16Px color="#F69139" data-testid="star-icon" /> : null}
      />
      <PreviewCardBody>
        {props.views && <ViewsTypography variant="caption">{props.views} views</ViewsTypography>}
        <ChipsWrapperStyled>
          {props.chips?.map((chip, index) => <PreviewChip key={index} color={chip.color} label={chip.label} />)}
        </ChipsWrapperStyled>

        <PreviewDescription>{props.description}</PreviewDescription>

        {!!props.lastRun && (
          <PreviewCardInfoWrapper>
            <InfoTypography variant="captionStrong">{t('Last run')}</InfoTypography>
            <InfoTypography variant="caption">{props.lastRun}</InfoTypography>
            <InfoTypography variant="captionStrong">{t('Views')}</InfoTypography>
            <InfoTypography variant="caption">{props.visualised}</InfoTypography>
          </PreviewCardInfoWrapper>
        )}
      </PreviewCardBody>
      <PreviewCardFooter
        action={
          <PreviewActionButton appearance="primary" onClick={props.handlePreviewAction} as="a">
            {props.action}
          </PreviewActionButton>
        }
      ></PreviewCardFooter>
    </PreviewCardWrapper>
  );
}

export default PreviewCard;
